import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from "@material-ui/icons/Visibility";

import { observer } from "mobx-react-lite";
import MatchFormModal from "./form";
import { stores } from "mobx-store";
import { Match } from "mobx-store/stores/afconStore";
import { useHistory } from "react-router-dom";
import StateFullContainer from "components/stateFullContainer";

const ListMatches: React.FC = observer(() => {
  const { afconStore } = stores;
  const [selectedMatch, setSelectedMatch] = useState<Match | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const history = useHistory();

  useEffect(() => {
    afconStore.fetchMatches();
  }, []);

  const handleOpenAdd = () => {
    setSelectedMatch(null);
    setIsModalOpen(true);
  };

  const handleOpenEdit = (match: Match) => {
    setSelectedMatch(match);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDelete = async (matchId: number) => {
    if (window.confirm("Are you sure you want to delete this match?")) {
      await afconStore.deleteMatch(matchId);
    }
  };

  const formatScore = (m: Match) => {
    if (m.homeGoals != null && m.awayGoals != null) {
      let score = `${m.homeGoals} - ${m.awayGoals}`;
      if (
        m.homePenaltyGoals != null &&
        m.awayPenaltyGoals != null &&
        (m.homePenaltyGoals !== m.homeGoals || m.awayPenaltyGoals !== m.awayGoals)
      ) {
        score += ` (${m.homePenaltyGoals}-${m.awayPenaltyGoals})`;
      }
      return score;
    }
    return "-";
  };

  return (
    <Container>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h4">AFCON Matches</Typography>
        <Button variant="contained" color="primary" onClick={handleOpenAdd}>
          Add Match
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Home</TableCell>
              <TableCell></TableCell>
              <TableCell>Away</TableCell>
              <TableCell>Score</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <StateFullContainer state={afconStore.matchesLoadState}>
              <>
                {afconStore.matches.map((match) => (
              <TableRow key={match.id}>
                <TableCell>
                  {new Date(match.matchDatetime).toLocaleString()}
                </TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    {match.homeTeamLogo && (
                      <img
                        src={match.homeTeamLogo}
                        alt={match.homeTeam}
                        style={{ width: 40, height: 40, marginRight: 8 }}
                      />
                    )}
                    {match.homeTeam}
                  </Box>
                </TableCell>
                <TableCell align="center">vs</TableCell>
                <TableCell>
                  <Box display="flex" alignItems="center">
                    {match.awayTeamLogo && (
                      <img
                        src={match.awayTeamLogo}
                        alt={match.awayTeam}
                        style={{ width: 40, height: 40, marginRight: 8 }}
                      />
                    )}
                    {match.awayTeam}
                  </Box>
                </TableCell>
                <TableCell>{formatScore(match)}</TableCell>
                <TableCell align="right">
                  <IconButton onClick={() => handleOpenEdit(match)}>
                    <EditIcon />
                  </IconButton>

                  <IconButton onClick={() => handleDelete(match.id)}>
                    <DeleteIcon />
                  </IconButton>

                  {/* Navigate to predictions page */}
                  <IconButton
                    color="primary"
                    onClick={() => history.push(`/afcon/matches/${match.id}/predictions`)}
                  >
                    <VisibilityIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
</>

</StateFullContainer>
           
          </TableBody>
        </Table>
      </TableContainer>

      <MatchFormModal
        open={isModalOpen}
        onClose={handleCloseModal}
        match={selectedMatch}
      />
    </Container>
  );
});

export default ListMatches;
